import { msg } from '@lingui/core/macro'
import { createFileRoute } from '@tanstack/react-router'
import { useProjectDetail } from '~/components/projects/project-detail'
import { ProjectVisitsTab } from '~/components/visits/project-visits-tab'
import { titleFor } from '~/lib/route-title'

/** Open to leads too: a levantamento happens long before a contract does. */
const ProjectVisitsRoute = () => {
  const project = useProjectDetail()

  return (
    <div className="px-5 pb-6">
      <ProjectVisitsTab projectId={project._id} />
    </div>
  )
}

export const Route = createFileRoute('/_authenticated/$workspaceSlug/projects/$projectId/visits')({
  component: ProjectVisitsRoute,
  head: () => ({ meta: [{ title: titleFor(msg`Visits`) }] }),
})
